// extracted by mini-css-extract-plugin
export default {"navActive":"dataXHeader_navActive__frlHG"};